import { useMemo } from './use-memo';
const useRef = (initialValue) => useMemo(() => ({
    current: initialValue
}), []);
export { useRef };
